export default __webpack_public_path__ + "static/media/insta.d94e021f.svg";